import IndexYunLiFang from '../components/companyGroupEmployerYunLiFang/Index';
import View from '@/components/common/view'
import EmployerEditYunLiFang from '../components/companyGroupEmployerYunLiFang/Edit';
import EmployerFillinYunLiFang from '../components/companyGroupEmployerYunLiFang/Fillin';
import EmployerConfirmYunLiFang from '../components/companyGroupEmployerYunLiFang/Confirm';
import EmployerFillinPersonYunLiFang from '../components/companyGroupEmployerYunLiFang/FillinPerson';
import EmployerFillinPersonSuccessYunLiFang from '../components/companyGroupEmployerYunLiFang/FillinPersonSuccess';


export default [
	{
		path:'',
		component:View,
		children:[
			{
				path:'',
				component:IndexYunLiFang
			},
			// {
			// 	path:'fillin/:id?',
			// 	component:EmployerFillinYunLiFang
			// },
			// {
			// 	path:'edit/:id',
			// 	component:EmployerEditYunLiFang
			// },
			{
				path:'confirm/:id',
				component:EmployerConfirmYunLiFang
			},
			{
				path:'order-detail/:id',
				component:EmployerConfirmYunLiFang
			},
			// {
			// 	path:'fillin-person/:policyId/:id',
			// 	component:EmployerFillinPersonYunLiFang,
			// 	meta:{
			// 		hideLogin:true
			// 	}
			// },
			{
				path:'fillin-person-success',
				component:EmployerFillinPersonSuccessYunLiFang,
				meta:{
					hideLogin:true
				}
			}
		]
	},
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/companyGroupEmployerYunLiFang.js